import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg-star2",
  "use": "svg-star2-usage",
  "viewBox": "0 0 28.193 26.814",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28.193 26.814\" fill=\"currentColor\" id=\"svg-star2\"><g transform=\"translate(-173.76 -69.188)\"><path d=\"m187.85 69.414 4.2897 8.6919 9.5921 1.3938-6.9409 6.7657 1.6385 9.5533-8.5794-4.5105-8.5794 4.5105 1.6385-9.5533-6.9409-6.7657 9.5921-1.3938z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol